const TIMEZONE = 'Europe/Madrid';

export function getCurrentDate() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: TIMEZONE }));
}

export function getTodayDate() {
  return getCurrentDate();
}

export function addDays(date, delta) {
  const d = new Date(date);
  d.setDate(d.getDate() + delta);
  return d;
}

export function compareDates(a, b) {
  const aa = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const bb = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  return aa.getTime() - bb.getTime();
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: TIMEZONE
  }).format(date);
}

export function getDayInfo(date) {
  return {
    dayNumber: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
  };
}
